import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Manage_User.css';
//mport { BASE_URL } from "./Constants.js";
import useAuth from './useAuth';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import * as XLSX from 'xlsx';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const Loader = () => (
    <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
        </div>
        <p>Loading...</p>
    </div>
);

// function to correct date format 2025-02-25 12:32:08.000000 to 10-02-2025
function correctDateFormat(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [day, month, year].join('-');
}




function Manage_Vehicle_Drivers() {
    useAuth();
    const [fueltypeData, setFueltypeData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [items, setItems] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10); // Number of items per page
    const navigate = useNavigate();
    const token = localStorage.getItem("authToken") || null;
    const [searchTerm, setSearchTerm] = useState('');

  

    // Add search input just after the card-header div:
    <div className="mb-3">
        <input
            type="text"
            className="form-control"
            placeholder="Search by name, BMID or mobile..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
        />
    </div>
    useEffect(() => {
        const fetchItems = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}getVehicleDrivers`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                if (result.status) {
                    setItems(result.data);
                    setFueltypeData(result.data);
                } else {
                    setError(result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setError('Failed to fetch items');
            } finally {
                setLoading(false);
            }
        };

        fetchItems();
    }, [navigate]);

    // Get current items
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
   // const currentItems = fueltypeData.slice(indexOfFirstItem, indexOfLastItem);
  // Filter function for search
  const filteredData = fueltypeData.filter(item => 
    item.fname?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.lname?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.emp_code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.mobile?.toLowerCase().includes(searchTerm.toLowerCase())
);

// Update current items to use filtered data
const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <section className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className='m-0' style={{ fontSize: '20px' }}>Manage Vehicle Drivers</h1>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <section className="col-lg-12 connectedSortable">
                                    <div className="card">
                                        <div className="card-header row">
                                            <div className="col-sm-4">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search by name, BMID or mobile..."
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                            <div className="col-sm-8">
                                            <span style={{ float: "right" }}>
                                                <Link to='/add_vehicle_drivers'>
                                                    <button type='button' className='btn btn-success'>
                                                        <i className="fas fa-plus"></i> Add New
                                                    </button>
                                                </Link>
                                            </span>
                                        </div></div>
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                {loading ? (
                                                    <Loader />
                                                ) : (
                                                    <>
                                                        <table className="table table-striped">
                                                            <thead>
                                                                <tr>
                                                                    <th>ID</th>
                                                                    <th>Driver Name</th>
                                                                    <th>BMID</th>
                                                                    <th>Mobile Number</th>
                                                                    <th>Licence Number</th>
                                                                    <th>Licence Type</th>
                                                                    <th>Licence Fromdate</th>
                                                                    <th>Licence Todate</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {currentItems.map((item) => (
                                                                    <tr key={item.id}>
                                                                        <td>{item.id}</td>
                                                                        <td>{item.fname} {item.lname}</td>
                                                                        <td>{item.emp_code}</td>
                                                                        <td>{item.mobile}</td>
                                                                        <td>{item.licence_no}</td>
                                                                        <td>{item.licence_type}</td>
                                                                        <td>{item.licence_fromdate}</td>
                                                                        <td>{item.licence_todate}</td>
                                                                        <td>
                                                                            <Link to={`/edit_vehicle_drivers/${item.id}`}>
                                                                                <button className="btn btn-primary btn-sm" title="Edit">
                                                                                    <i className="fas fa-edit"></i>
                                                                                </button>
                                                                            </Link>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                        <div className="pagination-container">
                                                            <ul className="pagination">
                                                                {Array.from({ length: Math.ceil(fueltypeData.length / itemsPerPage) }).map((_, index) => (
                                                                    <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                                                        <button
                                                                            onClick={() => paginate(index + 1)}
                                                                            className="page-link"
                                                                        >
                                                                            {index + 1}
                                                                        </button>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>

                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div >
                <Footer />
            </div >
        </div >
    );
}

export default Manage_Vehicle_Drivers

